import { Collection } from '@/kernel/collection';

import StringCell from '@/components/cells/string-cell.vue';
import DateCell from '@/components/cells/date-cell.vue';
import BooleanCell from '@/components/cells/boolean-cell.vue';
import EditCollectionCell from '@/components/cells/edit-collection-cell.vue';

import { DateRangeFilterAdapter, OrganisationFilterContextAdapter, OrganisationFormContextAdapter } from '@/kernel/adapters';

import DateRangeInput from '@/components/inputs/date-range-input.vue';
import TextInput from '@/components/inputs/text-input.vue';
import CheckboxInput from '@/components/inputs/checkbox-input.vue';

export class OrganisationAsset extends Collection {
  config = {
    autoRoute: true,
    requiresOrganisation: true,
    key: 'organisation-asset',
    pluralLabel: 'Assets',
    singleLabel: 'Asset',
    indexUrl: '/organisation-asset',
    createUrl: '/organisation-asset/create',
    searchKeys: ['name', 'isin'],
    editUrlPrefix: '/organisation-asset',
    idKey: 'id',
    nameKey: 'name',
    payloadEndpoint: '/organisation-asset',
    defaultSort: {
      key: 'name',
      order: 1
    },
    indexColumns: [
      {name: 'Actions', key: 'edit', sortable: false, cell: EditCollectionCell, props: {collection: 'organisation-asset'}},
      {name: 'Name', key: 'name', sortable: true, cell: StringCell},
      {name: 'ISIN', key: 'isin', sortable: false, cell: StringCell},
      {name: 'Updated', key: 'updatedAt', sortable: true, cell: DateCell},
      {name: 'Created', key: 'createdAt', sortable: true, cell: DateCell}
    ],
    indexFilters: [
      {key: 'updatedAt', label: 'Updated at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Updated at'}},
      {key: 'createdAt', label: 'Created at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Created at'}}
    ],
    indexContexts: [
      {key: 'organisation', adapter: OrganisationFilterContextAdapter}
    ],
    createFormContexts: [
      {key: 'organisation', adapter: OrganisationFormContextAdapter}
    ],
    createFormFields: [
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'isin', label: 'ISIN', input: TextInput, props: {label: 'ISIN'}}
    ],
    editFormFields: [
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'isin', label: 'ISIN', input: TextInput, props: {label: 'ISIN'}}
    ]
  }
}
